'use client'

import { Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import { LocationCombobox } from './location-combobox'
import { GuestStepper, ReservationDatePicker, ReservationTimePicker } from './reservation-controls'
import { createDiscoverySearchDefaults, type DiscoverySearchDefaults } from './search-defaults'

export function HeroSearch({ market, locationOptions, initialDefaults }: { market: string; locationOptions: string[]; initialDefaults: DiscoverySearchDefaults }) {
  const [date, setDate] = useState(initialDefaults.date)
  const [time, setTime] = useState(initialDefaults.time)
  const [partySize, setPartySize] = useState(2)

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      const localDefaults = createDiscoverySearchDefaults()
      setDate(localDefaults.date)
      setTime(localDefaults.time)
    }, 0)
    return () => window.clearTimeout(timeout)
  }, [])

  return (
    <form className="hero-search" action="/search" method="get" aria-label="Search reservations">
      <label className="search-segment search-segment--type search-segment--keyword">
        <Search size={18} />
        <span><small>Restaurant</small><input aria-label="Restaurant or cuisine" name="q" placeholder="Name or cuisine" autoComplete="off" /></span>
      </label>
      <LocationCombobox className="search-segment search-segment--location" value={market} suggestions={locationOptions} />
      <div className="search-segment search-segment--date">
        <ReservationDatePicker className="search-segment-control" name="date" value={date} min={todayDate()} onChange={setDate} />
      </div>
      <div className="search-segment search-segment--time"><ReservationTimePicker className="search-segment-control" name="time" value={time} onChange={setTime} includeAnyTime /></div>
      <GuestStepper className="search-segment search-segment--party" label="Party" name="partySize" value={partySize} max={12} onChange={setPartySize} />
      <button className="search-submit" type="submit">
        <Search size={19} />
        <span>Find a table</span>
      </button>
    </form>
  )
}

function todayDate() {
  const date = new Date()
  return toLocalDate(date)
}

function toLocalDate(date: Date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
